import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Cookies from "js-cookie";
const axios = require("axios");

const theme = createTheme({
  palette: {
    primary: { main: "#26477c" },
  },
});
const jwt = require("jsonwebtoken");

const Alarms = ({ currentOrganisation, unClearedAlarms, alarms }) => {
  let authObj = Cookies.get("authObj");
  authObj = JSON.parse(authObj);
  let { token, userType } = authObj;
  let dataLoaded = unClearedAlarms && alarms;
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirm] = useState(false);
  const [MQTTBody, setMQTTBody] = useState({
    ID: "",
    ts: "",
    type: "",
    username: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseAndConfirm = () => {
    setOpen(false);
    setConfirm(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let authObj = Cookies.get("authObj");
    authObj = JSON.parse(authObj);
    let { token } = authObj;
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };

    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
        apikey: apiKeys["admin"],
      },
    };

    if (confirmed) {
      // setConfirm(false);
      axios
        .post(`${process.env.REACT_APP_API}/publishMQTT`, MQTTBody, config)
        .then((response) => {
          console.log(response);
          setConfirm(false);
        })
        .catch(function (error) {});
    }
  }, [confirmed]);
  if (dataLoaded) {
    for (let i = 0; i < unClearedAlarms.length; i++) {
      unClearedAlarms[i]["id"] = i + 1;
    }

    let hideAddress = false;
    if (currentOrganisation === "ntuGomic") {
      hideAddress = true;
    }

    for (let i = 0; i < unClearedAlarms.length; i++) {
      let unClearAlarm = unClearedAlarms[i];
      let { ts: TimeStamp } = unClearAlarm;
      let [date, time] = TimeStamp.split(" ");
      let [year, month, day] = date.split("-");

      let ts = `${day}-${month}-${year} ${time}`;
      unClearedAlarms[i]["convertedTS"] = ts;
    }

    let tsField = "ts";
    let alarmHeader = "Fault Type";

    if (currentOrganisation === "ntuGomic") {
      tsField = "convertedTS";
      alarmHeader = "Alarm Type";
    }
    let columns = [
      {
        editable: false,
        hide: true,
        headerName: "#",
        field: "id",
      },
      {
        editable: false,
        hide: false,
        headerName: "EquipmentID",
        field: "EquipmentID",
        width: 170,
      },
      {
        editable: false,
        hide: false,
        headerName: "TimeStamp",
        field: tsField,
        width: 170,
      },
      {
        editable: false,
        hide: hideAddress,
        headerName: "Address",
        field: "shortAddress",
        width: 150,
      },
      {
        editable: false,
        hide: false,
        headerName: alarmHeader,
        field: "Type",
        width: 150,
      },
      {
        editable: false,
        hide: false,
        headerName: "Alarm Status",
        field: "CurrentStatus",
        width: 180,
      },
      {
        editable: true,
        hide: false,
        headerName: "",
        field: "Clear Alarm",
        // align: 'center'
        width: 160,
        renderCell: (params) => {
          return (
            <span style={{ cursor: "pointer" }}>
              <AccessAlarmIcon onClick={handleClickOpen} />
            </span>
          );
        },
      },
      // {
      //   field: '',
      //   headerName: 'Action',
      //   renderCell: (params) => <strong>hii{console.log(params)}</strong>,
      // },
    ];

    //ntu Gomic no need clear alarm
    if (currentOrganisation === "ntuGomic") {
      columns.splice(-1, 1);
    }

    if (userType === "user") {
      let tempColumn = [];
      for (let column of columns) {
        if (column["field"] !== "Clear Alarm") {
          tempColumn.push(column);
        }
      }
      columns = tempColumn;
      tempColumn = undefined;
    }

    let datagridData = { columns: columns, rows: unClearedAlarms };
    return (
      <div style={{ height: 400 }}>
        <ThemeProvider theme={theme}>
          <DataGrid
            {...datagridData}
            GridColDef={{ align: "center" }}
            // components={{
            //   Toolbar: GridToolbar,
            // }}
            onCellClick={(event) => {
              let field = event.field;
              if (field === "Clear Alarm") {
                let authObj = Cookies.get("authObj");
                authObj = JSON.parse(authObj);
                let { token } = authObj;
                let decodedAuthObj = jwt.verify(
                  token,
                  "6jFLnuPANxk4UzePcRSTRkwXSqxhAMf2FAm4VFvV"
                );
                let row = event.row;
                let username = decodedAuthObj["username"];
                let { EquipmentID, ts, Type: type } = row;
                setMQTTBody({
                  ...MQTTBody,
                  ["ID"]: EquipmentID,
                  ["ts"]: ts,
                  ["type"]: type,
                  ["username"]: username,
                });
              }
            }}
            filterModel={{
              items: [
                // {
                //   columnField: 'commodity',
                //   operatorValue: 'contains',
                //   value: 'rice',
                // },
              ],
            }}
          />
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            {/* <DialogTitle id='form-dialog-title'>Subscribe</DialogTitle> */}
            <DialogContent>
              <DialogContentText>
                Are you sure to clear this alarm
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleCloseAndConfirm} color="primary">
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    );
  } else {
    return <h1>Loading Alarms Data....</h1>;
  }
};

export default Alarms;
